import HomeComponent from '@/components/pages/Home'
import type { NextPage } from 'next'
import { GetServerSideProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'

// Libs

// Components

// Constants

// Styles

// Variables

const Home: NextPage = () => {
  return (
    <>
      <Head>
        <title>{'Live Mall Club'}</title>
      </Head>
      <HomeComponent />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale as string, ['common'])),
    },
  }
}

export default Home
